import React from "react";
import { Box, Typography } from "@mui/material";
import { green, red } from "@mui/material/colors";

interface PillButtonProps {
  label: string;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
  isCheckAnswer?: boolean;
  isCorrectAnswer?: boolean;
}

const PillButton: React.FC<PillButtonProps> = ({
  label,
  selected,
  disabled,
  onClick,
  isCorrectAnswer = false,
  isCheckAnswer = false,
}) => {
  const isGreen = isCheckAnswer && selected && isCorrectAnswer;
  const isRed = isCheckAnswer && selected && !isCorrectAnswer;
  return (
    <Box
      onClick={() => {
        if (!disabled) onClick();
      }}
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: "1px solid",
        borderColor:
          selected || isGreen || isRed ? "primary.main" : "primary.light",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "default" : "pointer",
        bgcolor: isGreen
          ? "answer.correct"
          : isRed
            ? "answer.incorrect"
            : selected
              ? "primary.light"
              : "transparent",
        color: "text.primary",
        transition: "all 0.15s ease",
        userSelect: "none",
      }}
    >
      <Typography variant="subtitle2" fontWeight={500}>
        {label}
      </Typography>
    </Box>
  );
};

export default PillButton;
